import {Component, OnInit} from '@angular/core';
import {
  CreateObservationTypeGroup,
  ObservationDialogData,
  ObservationGroupTypeDto,
  ObservationTypeGroup
} from '../../../../../shared/models/observation-group';
import {MatDialog} from '@angular/material/dialog';
import {ObservationManagementService} from '../../../../../data/observations/observation-management.service';
import {
  CreateObservationGroupDialogComponent
} from '../dialogs/create-observation-group-dialog/create-observation-group-dialog.component';
import {
  DeleteObservationGroupDialogComponent
} from '../dialogs/delete-observation-group-dialog/delete-observation-group-dialog.component';
import {ToastService} from '../../../../../shared/services/toast.service';
import {MapStyles} from '../../../../../configuration/map-styles';
import {firstValueFrom} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {MatButton, MatIconButton} from '@angular/material/button';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {
  CardContentDirective,
  CardContentRawDirective
} from '../../../../../shared/components/card/card-content.directive';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatDivider, MatListItem, MatListItemMeta, MatListItemTitle, MatNavList} from '@angular/material/list';
import {RouterLink} from '@angular/router';
import {RootRoute, SettingsRoute} from '../../../../../shared/models/angular-routing';
import {MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';
import {
  DialogSingleFieldEditComponent,
  SingleFieldEditData
} from '../../manage-vehicles/dialogs-vehicle/dialog-single-field-edit.component';
import {
  AssignObservationGroupToVehicleGroupsDialogComponent
} from '../dialogs/assign-observation-group-to-vehicle-groups-dialog/assign-observation-group-to-vehicle-groups-dialog.component';

@Component({
  selector: 'app-observations-group-list',
  templateUrl: './observations-group-list.component.html',
  styleUrls: ['../../../settings-common.scss'],
  imports: [
    FormsModule,
    MatButton,
    CardComponent,
    CardContentDirective,
    MatProgressSpinner,
    CardContentRawDirective,
    MatNavList,
    MatListItem,
    MatListItemTitle,
    RouterLink,
    MatDivider,
    MatMenu,
    MatMenuContent,
    MatMenuItem,
    MatIconButton,
    MatListItemMeta,
    MatMenuTrigger,
    MatIcon,
  ]
})
export class ObservationsGroupListComponent implements OnInit {

  isLoading = true;

  observationTypeGroups: ObservationTypeGroup[] = [];

  protected readonly SettingsRoute = SettingsRoute;
  protected readonly RootRoute = RootRoute;

  constructor(
    private readonly observationManagementService: ObservationManagementService,
    private readonly dialog: MatDialog,
    private readonly toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.loadData();
  }

  addObservationTypeGroupDialog(): void {
    const dialogRef = this.dialog.open(CreateObservationGroupDialogComponent, {
      width: '450px',
      data: {
        name: '',
        duration: 0,
        isAudible: false,
        mapColor: null,
        defaultMapColor: MapStyles.LIVE_COLOR,
      },
    });

    dialogRef.afterClosed().subscribe((response?: ObservationDialogData) => {
      if (response) {
        this.observationManagementService.createObservationTypeGroup({...response} as CreateObservationTypeGroup)
          .then(() => {
            this.toastService.long('Group has been added');
            this.loadData();
          });
      }
    });
  }

  removeGroup(deleted: ObservationTypeGroup) {
    const dialogRef = this.dialog.open(DeleteObservationGroupDialogComponent, {
      width: '450px',
      data: deleted,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.observationManagementService.deleteObservationTypeGroup(deleted.id).then(() => {
          this.loadData();
          this.toastService.short('Observation type group has been deleted');
        }).catch(error => {
          this.toastService.long('Error while deleting observation group');
          console.log(error);
        });
      }
    });
  }

  changeGroupName(group: ObservationGroupTypeDto) {
    const ref = this.dialog.open(DialogSingleFieldEditComponent, {
      width: '500px',
      data: {
        title: 'Rename Group',
        fieldName: 'Group Name',
        actionLabel: 'Change Group Name', value: group.name,
        action: value => {
          return this.observationManagementService.updateObservationTypeGroup(group.id, {...group, name: value});
        }
      } as SingleFieldEditData
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  assignVehiclesToGroup(group: ObservationGroupTypeDto) {
    const ref = this.dialog.open(AssignObservationGroupToVehicleGroupsDialogComponent, {
      minWidth: '700px',
      data: group
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.loadData();
        this.toastService.long('Group assignments has been updated');
      }
    });
  }

  private loadData() {
    this.isLoading = true;
    this.observationManagementService.getObservationTypeGroups()
      .then(result => {
        this.observationTypeGroups = result;
      })
      .catch(error => {
        const msg = 'Error while loading data from server';
        this.toastService.long(msg);
        console.error(`${msg} :: ${error}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
